import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {tdaInternalBanners, tdaInternalSpanishEbookBanner} from "../constants/tda_internal_banners";

export function useTdaPlaceholderBanner() {
    const isAbroad = useOfferListingAbroadView();

    if (isAbroad) {
        return tdaInternalSpanishEbookBanner;
    }

    return tdaInternalBanners[0];
}
import {useOfferListingAbroadView} from "../../offer/list/hooks/use_offer_listing_abroad_view_check";
import {tdaInternalBanners, tdaInternalSpanishEbookBanner} from "../constants/tda_internal_banners";

export function useTdaPlaceholderBanner() {
    const isAbroad = useOfferListingAbroadView();

    if (isAbroad) {
        return tdaInternalSpanishEbookBanner;
    }

    return tdaInternalBanners[0];
}
